import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { ClientEnv } from 'constants/Chat.constants';
import { JupiterClientEnvironment } from 'constants/Chat.constants';

import { createNewChat, projectInit } from 'actions';

export interface ChatPanelState {
  isChatPanelOpen: boolean;
  clientEnv: ClientEnv;
  variantName: string;
  channel: string;
}

export const NO_VARIANT_NAME = 'No variant';

const initialState: ChatPanelState = {
  isChatPanelOpen: false,
  clientEnv: JupiterClientEnvironment.DRAFT,
  variantName: NO_VARIANT_NAME,
  channel: 'chat.polyai',
};

const chatPanelSlice = createSlice({
  name: 'chatPanel',
  initialState,
  reducers: {
    openChatPanel: state => {
      state.isChatPanelOpen = true;
    },
    closeChatPanel: state => {
      state.isChatPanelOpen = false;
    },
    toggleChatPanel: state => {
      state.isChatPanelOpen = !state.isChatPanelOpen;
    },
    setClientEnv: (state, { payload: clientEnv }: PayloadAction<ClientEnv>) => {
      state.clientEnv = clientEnv;
    },
    setVariantName: (
      state,
      { payload: variantName }: PayloadAction<string>,
    ) => {
      state.variantName = variantName;
    },
    setChannel: (state, { payload: channel }: PayloadAction<string>) => {
      state.channel = channel;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(projectInit, () => {
        return { ...initialState };
      })
      .addCase(createNewChat, state => {
        state.isChatPanelOpen = true;
      });
  },
});

export const {
  openChatPanel,
  closeChatPanel,
  toggleChatPanel,
  setClientEnv,
  setVariantName: setVariantName,
  setChannel,
} = chatPanelSlice.actions;

export default chatPanelSlice.reducer;
